import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import * as moment from 'moment';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../enums/app-settings.enum';
import { environment } from 'src/environments/environment';
import { AccountService } from 'src/app/services/account.service';
import { CustomerfeedbackmanagementService } from 'src/app/services/customerfeedbackmanagement.service';
@Component({
  selector: 'app-arena-pro-success',
  templateUrl: './arena-pro-success.component.html',
  styleUrls: ['./arena-pro-success.component.scss']
})
export class ArenaProSuccessComponent implements OnInit, OnDestroy {
  transactionId;
  mobileNumber;
  billType;
  price;
  addonType;
  isPDPAllowed;
  sku;
  ENV: string = '';
  URLS: any;
  devices: any;
  lang:any='';
  isTravelInsuranceAddon:boolean = false;
  currentLanguage: string;
  userLoggedIn: boolean;
  userData: any;
  constructor(
    private SKUDS: SkuDataService,
    private SS: SubjectService,
    private UTS: UtilitiesService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private AS: AccountService,
    private CFM: CustomerfeedbackmanagementService
  ) {
    this.lang = this.UTS.getLocaleLanguage();
    this.SS.areanProAddonBuySuccessfully.subscribe((r) => {
      if (r && r.success == true) {
        const data = r.data;
        if (data && data.transactionNo) this.transactionId = data.transactionNo;
      }
      if (r && r.mobileNumber) {
        this.mobileNumber = r.mobileNumber;
      }
      if (r && r.billType) {
        this.billType = r.billType;
      }
      if (r && r.price) {
        this.price = r.price;
      }
      if (r && r.addonType) {
        this.addonType = r.addonType;
      }
    });
    this.SS.skuDetails.subscribe((sku) => {
      if(sku){
        this.isPDPAllowed =sku && sku?.isPDPAllowed ? sku?.isPDPAllowed: false;
       }
    })
   }

  ngOnInit(): void {
    this.ENV = this.UTS.getENV();
    this.sku = this.SKUDS.get();
    this.route.queryParams.subscribe((q) => {
      if (q && q.env) {
        this.UTS.setENV(q.env);
        this.ENV = q.env;
      } else {
        this.ENV = this.UTS.getENV();
      }
      
    this.sku = this.SKUDS.get();
    this.cdr.detectChanges();
    console.log(this.sku)
    });
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.getNAVURLs();
    let successAreanPro = localStorage.getItem('successAreanPro')
    this.devices = JSON.parse(localStorage.getItem('selectedDevices')) || [];
    if(successAreanPro){
      const arenaProdata = JSON.parse(successAreanPro);
      if (arenaProdata && arenaProdata?.success == true) {
        const data = arenaProdata?.data;
        if (data && data.transactionNo) this.transactionId = data?.transactionNo;
      }
      if (arenaProdata && arenaProdata?.mobileNumber) {
        this.mobileNumber = arenaProdata?.mobileNumber;
      }
      if (arenaProdata && arenaProdata?.billType) {
        this.billType = arenaProdata?.billType;
      }
      if (arenaProdata && arenaProdata?.price) {
        this.price = arenaProdata?.price;
      }
      if (arenaProdata && arenaProdata?.addonType) {
        this.addonType = arenaProdata?.addonType;
      }
    }
    
    this.AS.UserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userLoggedIn = true;
          this.CFM.checkcustomerFeedback(r);
        }
      },
      () => {
        this.CFM.userNotLogin()
      }
    );
    setTimeout(() => {
      this.checkAndRunTransactionalSurvey();
    }, 10000);
  }
  today() {
    const lang = this.UTS.getLocaleLanguage();
    if (lang == 'ar') {
      moment.locale('ar-sa');
      return moment(Date.now()).format('Do MMM, YYYY');
    } else {
      moment.locale('en');
      return moment(Date.now()).format('Do MMM, YYYY'); // 13th April, 2020
    }
  }
  getNAVURLs() {
    this.route.queryParamMap.subscribe((params) => {
      const token: any = { ...params };
      const parentLanguage = localStorage.getItem('curr_language');
      const parentLang = parentLanguage
        ? parentLanguage.toLocaleLowerCase()
        : 'english';
      localStorage.removeItem('language');
      const localLanguage = localStorage.getItem('language');
      const lang = token.params.locale
        ? token.params.locale.toLowerCase()
        : token.params.lang
          ? token.params.lang.toLowerCase()
          : localLanguage
            ? localLanguage.toLocaleLowerCase()
            : 'en';

      if (lang === 'ar' || parentLang === 'arabic') {
        this.URLS = {
          APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'ar' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'ar' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
          APPLICATION_FAQ_URL: 'ar' + AppSettings.FAQ_URL,
          POSTPAID_MIGRATION_BANNER: 'ar' + AppSettings.POSTPAID_MIGRATION_BANNER,
          ROAMING_ADDONS: 'ar' + AppSettings.ROAMING_ADDONS
        };
      } else {
        this.URLS = {
          APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
          APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
          APPLICATION_NAVIATION_URL:
            'en' + AppSettings.APPLICATION_NAVIATION_URL,
          APPLICATION_QLINKS_FOOTER_URL:
            'en' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
          APPLICATION_FAQ_URL: 'en' + AppSettings.FAQ_URL,
          POSTPAID_MIGRATION_BANNER: 'en' + AppSettings.POSTPAID_MIGRATION_BANNER,
          ROAMING_ADDONS: 'en' + AppSettings.ROAMING_ADDONS
        };
      }
    });
  }

  dismiss(){
    window.location.href = `${window.location.origin}/b2c?locale=${this.lang}`;
  }
  gotTOAddons(){
    const OS = this.UTS.getMobileOperatingSystem();
    this.ENV = this.UTS.getENV();
    if (this.ENV == 'mobile') {
      if (OS == 'Android') {
        (window as any).deals.goBack();
      } else {
        (window as any).webkit.messageHandlers.hybridInterface.postMessage('goBack');
      }
    }else{
      window.location.href =environment.HOST + `/b2c/addon/addonsApp/addons?locale=${this.currentLanguage}`;
    }
      
  }
  gotoSubscribeAddon(){
    const OS = this.UTS.getMobileOperatingSystem();
    this.ENV = this.UTS.getENV();
    if (this.ENV == 'mobile') {
      if (OS == 'Android') {
        const payload = JSON.stringify({ accountNumber: this.mobileNumber });
        (window as any).deals.gotoSubscribeAddonPage(payload);
      } else {
        const messgeToPost = {
          method: 'gotoSubscribeAddonPage',
          accountNumber: this.mobileNumber,
        };
        const passData: string = JSON.stringify(messgeToPost);
        (
          window as any
        ).webkit.messageHandlers.hybridInterface.postMessage(passData)
      }
    }else{
      window.location.href =environment.HOST + `/ecare/d/account-services/manage-extras`;
    }
  }
  checkAndRunTransactionalSurvey() {
    const transactionalSurvey = JSON.parse(localStorage.getItem('transactionalSurvey'));

    if (transactionalSurvey) {
      this.callCFMScriptAuto();
    }
  }

  callCFMScriptAuto() {
    // Check if QSI is defined and if required methods are available
    if (window['QSI'] && typeof window['QSI'].API === 'object') {
      console.log("inside 1st if of QSI");
      const QSI = window['QSI'].API;

      // Check if the expected methods exist
      if (typeof QSI.unload === 'function' &&
          typeof QSI.load === 'function' &&
          typeof QSI.run === 'function') {
        // Invoke the methods
        QSI.unload();
        QSI.load();
        QSI.run();
      } else {
        console.error("Required QSI API methods are not defined.");
      }
    } else {
      console.error("QSI is not defined or QSI.API is not an object.");
    }
  }

  ngOnDestroy(): void {
    const transactionalSurvey = JSON.parse(localStorage.getItem('transactionalSurvey'));
    if (transactionalSurvey) {
      localStorage.removeItem('transactionalSurvey');
    }
    const relationalSurvey = JSON.parse(localStorage.getItem('relationalSurvey'));
    if (relationalSurvey) {
      localStorage.removeItem('relationalSurvey');
    }
  }
}
